import React from "react";
import { SecureNavigationBeacon } from "@trp-ii-ii-component-library/ii-components";

import "./NavigationContainer.scss";
import { useSelector } from "react-redux";
import { getProductTypes } from "../../redux/modules/productTypes/productTypes.selectors";
import { PRODUCT_TYPE_ENUM_MAP } from "../../settings/settings";
import { getRelationshipManagerData } from "../../redux/modules/manager/relationshipManager.selectors";
import config from "../../config/config";
import { isCustomerWebViewEnabled } from "../../redux/modules/customer/customer.selectors";
import {
  getIsEligibleRMD,
  getUserMessagesCount
} from "../../redux/modules/PersonalInformation/personalInformation.selectors";
import { getUserAllFunds } from '../../redux/modules/UserFunds/userFunds.selectors';
import {getRMDSummary} from "../../redux/modules/RMD/RMDSetting.selectors";
import { getIsMobileParam } from "../../redux/modules/applicationConfig/applicationConfig.selectors";

export function NavigationContainer() {
  const productType = useSelector(getProductTypes);
  const rm = useSelector(getRelationshipManagerData);
  const isEligibleForRMD = useSelector(getIsEligibleRMD);
  const rmdSummaryInfo = useSelector(getRMDSummary);
  const messageCount = useSelector(getUserMessagesCount);
  const userFunds = useSelector(getUserAllFunds);
  const customerWebViewEnabled = useSelector(isCustomerWebViewEnabled);
  const isMobileParam = useSelector(getIsMobileParam);
  const {
    hasAPP,
    hasRAS,
    hasBrokerage,
    hasMutualFund,
    hasNAT529,
    hasMD529,
    hasAK529
  } = productType || {};
  const accounts = [];
  if (hasMutualFund) {
    accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP["MUTUAL_FUND"] });
  }
  if (hasAK529) {
    accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP["ALASKA_529"] });
  }
  if (hasNAT529) {
    accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP["NATIONAL_529"] });
  }
  if (hasMD529) {
    accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP["MARYLAND_529"] });
  }
  if (hasBrokerage) {
    accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP["BROKERAGE"] });
  }
  if (hasAPP) {
    accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP["MANAGED_ACCOUNT"] });
  }
  if (hasRAS) {
    accounts.push({ productType: PRODUCT_TYPE_ENUM_MAP["RETIREMENT_ADVISORY"] });
  }
  const relationshipManager = rm?.person
    ? {
        email: rm.email,
        location: rm.location,
        person: rm.person,
        phone: rm.officePhone,
        title: rm.primaryJobTitle,
        headshot: `${config.rmlUrl}${rm.color96x96.path}`,
        profile: `${
          config.userUrl
        }${rm.person.firstName.toLowerCase()}-${rm.person.lastName.toLowerCase()}.html`,
      }
    : undefined;

  const agreementMap = {
    TRADITIONAL_IRA: 6,
    ROTH_IRA: 7,
    JOINT_TENANT_TOD: 26,
    ESA: 9,
    POA: 40,
  };
  let acctObj;
  if (userFunds) {
    acctObj = userFunds?.map((fund) => {
      const a = {
        productType: PRODUCT_TYPE_ENUM_MAP[fund.productType],
      };
      if (agreementMap[fund.agreementType]) {
        a.accountTypeId = agreementMap[fund.agreementType];
      }
      return a;
    })
      .concat(accounts);
  } else {
   acctObj = [].concat(accounts);
  }
  return isMobileParam ? null : (
    <div className="navigation-font">
      <SecureNavigationBeacon
        authentication={{
          authorization: {
            isCustomerWebView: customerWebViewEnabled,
            isAuthenticated: true,
          },
          loginUrl: "",
          user: {
            messageCount,
            relationshipManager,
            isRMDEligible: isEligibleForRMD || rmdSummaryInfo?.preRMDEligible,
          },
        }}
        data={{
          accounts: acctObj,
          showMainMenu: true,
          showContextualNav: true,
          brokerageTradingEnabled: true,
        }}
      />
    </div>
  );
}

export default NavigationContainer;
